module.exports = __webpack_public_path__ + "static/media/logos-cartoes.d77f129d.png";